import { render, staticRenderFns } from "./createSettlement.vue?vue&type=template&id=053b752e&scoped=true&"
import script from "./createSettlement.vue?vue&type=script&lang=js&"
export * from "./createSettlement.vue?vue&type=script&lang=js&"
import style0 from "./createSettlement.vue?vue&type=style&index=0&id=053b752e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053b752e",
  null
  
)

export default component.exports